import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const WredCtaBanner: React.FC = () => (
  <section className="wred-cta-banner" aria-labelledby="wred-cta-title">
    <div className="wred-cta-banner__dots" aria-hidden="true" />
    <div className="wredesign-container wred-cta-banner__inner">
      <motion.div
        className="wred-cta-banner__content"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.55 }}
      >
        <span className="wred-cta-banner__eyebrow">Ready to Revamp?</span>
        <h2 id="wred-cta-title">Transform Your Website Today</h2>
        <p>
          Partner with WebTech to redesign your website with modern design, better performance,
          and features that drive real business growth.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.98 }}
      >
        <Link className="wred-cta-banner__btn" to="/contact">
          <span>Start Your Redesign</span>
          <span className="wred-cta-banner__btn-icon" aria-hidden="true">
            <ArrowRight size={18} strokeWidth={2} />
          </span>
        </Link>
      </motion.div>
    </div>
  </section>
);

export default WredCtaBanner;
